import { observer } from 'mobx-react';
import deliveryZonesStore from '../../stores/deliveryZonesStore';
import theme from 'src/constants/styles';
import { DELIVERY_ZONE_TYPE, IDeliveryZone } from 'src/types/deliveryManagment';
import { CoordsBounds } from 'src/types/main';
import { boundsToPath } from 'src/utils/formatter';
import { Circle } from 'src/view/components/Map/Circle/Circle';
import { Polygon } from 'src/view/components/Map/Polygon/Polygon';

const DeliveryZonesDraftAreas = observer(() => {
  if (!deliveryZonesStore.draft) return null;

  const color = deliveryZonesStore.draft?.branch ? deliveryZonesStore.draft.color : theme.colors.gray2;

  const onCircleEdit = (radius: number) => {
    deliveryZonesStore.editDraftZone('radius', radius);
    // if (deliveryZonesStore.draft?.branch) {
    //   const bounds = circleToPolygon(
    //     {
    //       lat: deliveryZonesStore.draft.branch.latitude,
    //       lng: deliveryZonesStore.draft.branch.longitude,
    //     },
    //     radius,
    //     1
    //   );
    //   deliveryZonesStore.editDraftZone('bounds', bounds);
    // }
    // const bounds = pathToBounds(circleToPolygon(deliveryZonesStore.draft?.branch))
  };

  const onPolygonEdit = (bounds: CoordsBounds) => deliveryZonesStore.editDraftZone('bounds', bounds);

  if (deliveryZonesStore.draft.type === DELIVERY_ZONE_TYPE.RADIUS) {
    if (!deliveryZonesStore.draft.branch || !deliveryZonesStore.draft.radius) return null;

    return (
      <Circle<IDeliveryZone>
        allowFloat
        onEdit={onCircleEdit}
        radius={Number(deliveryZonesStore.draft.radius)}
        color={color}
        index={deliveryZonesStore.pagination.data.length}
        center={{
          lat: deliveryZonesStore.draft.branch?.latitude,
          lng: deliveryZonesStore.draft.branch?.longitude,
        }}
      />
    );
  }

  if (deliveryZonesStore.draft.type === DELIVERY_ZONE_TYPE.PLYGON) {
    if (deliveryZonesStore.draft.bounds.length < 3) return null;
    return (
      <>
        <Polygon
          index={deliveryZonesStore.pagination.data.length}
          editable
          draggable={false}
          onEdit={onPolygonEdit}
          color={color}
          paths={boundsToPath(deliveryZonesStore.draft.bounds)}
        />
      </>
    );
  }

  return null;
});

export default DeliveryZonesDraftAreas;
